import React from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { useTr } from "@/autoTranslate";

const words = [
  "koordinasyon",
  "diplomasi",
  "marka sesi",
  "sosyal strateji",
  "kültürler arası",
  "lojistik",
  "editoryal düşünce",
  "proje yönetimi",
  "jeopolitik",
  "araştırma",
];

export default function Marquee() {
  const tr = useTr();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const x = useTransform(scrollYProgress, [0, 1], ["0%", "-25%"]);

  return (
    <section
      ref={ref}
      data-testid="marquee-section"
      className="relative py-5 md:py-8 border-y border-[color:var(--hair)] overflow-hidden"
    >
      <motion.div style={{ x }} className="flex items-center">
        <div className="marquee-track whitespace-nowrap font-serif-editorial italic font-light text-[9vw] md:text-[3.2vw] leading-none opacity-90">
          {[...words, ...words].map((w, i) => (
            <span key={i} className="flex items-center gap-6 pr-6">
              {w}
              <span
                className="inline-block w-2 h-2 md:w-2.5 md:h-2.5 rounded-full"
                style={{
                  background:
                    i % 3 === 0
                      ? "var(--cobalt)"
                      : i % 3 === 1
                      ? "var(--coral)"
                      : "var(--chartreuse)",
                }}
              />
            </span>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
